import { CEAlertSubscriptionAttributesBase } from './ce-alert-subscription-attributes-base'


export class CEAlertSubscriptionAttributes extends CEAlertSubscriptionAttributesBase {

}